import { render, staticRenderFns } from "./CaseInfoSection.vue?vue&type=template&id=46648ecc&"
import script from "./CaseInfoSection.vue?vue&type=script&lang=js&"
export * from "./CaseInfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports